<template>
  <div class="form-list">
    <el-form
      class="form"
      ref="form"
      :rules="rules"
      :model="student"
      label-position="right"
      label-width="130px"
    >
      <el-form-item label="姓名">
        {{ student.student_name }}

        <router-link :to="RouteConfig.studentDetail.to(id)" class="primary-color">查看学员主页</router-link>
      </el-form-item>
      <el-form-item label="昵称">
        {{ student.nickname }}
      </el-form-item>
      <el-form-item label="真人自拍">
        <v-avatar :value="student.selfie" :size="100"/>
      </el-form-item>
      <el-form-item label="小程序头像">
        <v-avatar :value="student.avatar" :size="100"/>
      </el-form-item>
      <el-form-item label="注册时间">
        {{ student.add_time | timeToYmdHi }}
      </el-form-item>
      <el-form-item label="注册来源">
        {{ student.store_name }}
      </el-form-item>
      <el-form-item label="手机号">
        <template v-if="student.phone">{{student.phone}}</template>
        <span v-else class="accent-color">未填写</span>
      </el-form-item>
      <el-form-item label="会员号">
        <template v-if="student.card_number">{{student.card_number}}</template>
        <span v-else class="accent-color">未填写</span>
      </el-form-item>
      <el-form-item label="实名证件号" prop="id_number">
        <template v-if="student.id_number">{{student.id_number}}</template>
        <span v-else class="accent-color">未填写</span>
      </el-form-item>
      <el-form-item label="拥有课卡数量" prop="id_number">
        {{ student.card_count }}
      </el-form-item>
      <el-form-item v-if="!student.is_deleting" label="注销原因" prop="delete_cause">
        <template v-if="student.is_del">{{ student.delete_cause }}</template>
        <template v-else>
          <el-input
            v-if="!isLoading"
            type="textarea"
            :autosize="{ minRows: 5, maxRows: 20}"
            v-model="student.delete_cause"
            maxlength="120"
            show-word-limit
          />
        </template>
      </el-form-item>
      <template v-if="student.is_del">
        <el-form-item label="注销申请者">
          <v-avatar-nickname :value="student.apply_avatar" :nickname="student.apply_nickname"/>
        </el-form-item>
        <el-form-item label="注销申请门店">
          {{ student.apply_store_name || '' }}
        </el-form-item>
        <el-form-item label="注销申请时间">
          {{ student.apply_time | timeToYmdHi }}
        </el-form-item>
        <el-form-item label="注销通过者">
          <v-avatar-nickname :value="student.examine_avatar" :nickname="student.examine_nickname"/>
        </el-form-item>
        <el-form-item label="注销通过时间">
          {{ student.examine_time | timeToYmdHi }}
        </el-form-item>
      </template>

      <el-form-item>
        <template v-if="!isLoading">
          <template v-if="!student.is_del">
            <template v-if="!student.is_deleting">
              <el-button
                v-if="isAdministrator"
                type="danger"
                :loading="isDeleting"
                :disabled="!!student.is_del"
                @click="confirmDelete"
              >
                确认注销
              </el-button>
              <el-button
                v-else
                type="danger"
                :loading="isDeleting"
                :disabled="!!student.is_del"
                @click="applyDelete"
              >
                申请注销
              </el-button>
            </template>

            <el-button v-else type="danger" :disabled="true">注销申请审核中</el-button>
          </template>
        </template>

        <el-button @click="RouteConfig.studentList.back">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import RouteConfig from '@/router/config';
import { destroy, show } from '@/api/student';
import { store } from '@/api/student-deletion-request';
import { mapGetters } from 'vuex';

export default {
  name: RouteConfig.studentDeleteDetail.name,
  data: () => ({
    RouteConfig,
    isLoading: false,
    isDeleting: false,
    delete_cause: '',
    student: {
      add_time: '',
      update_time: '',
      student_name: '',
      nickname: '',
      phone: '',
      id_number: '',
      avatar: '',
      selfie: '',
      card_number: '',
      used_card_id: '',
      store_name: '',
      card_count: 0,
      is_del: 0,
      delete_cause: '',
      is_deleting: 1,
      apply_time: 0,
      apply_avatar: '',
      apply_nickname: '',
      apply_store_name: '',
      examine_time: 0,
      examine_avatar: '',
      examine_nickname: '',
    },
    rules: {
      delete_cause: [{ required: true, message: '请输入注销原因', trigger: 'change' }],
    },
  }),
  computed: {
    id() {
      return +this.$route.params.id || 0;
    },
    ...mapGetters([
      'isAdministrator',
    ]),
  },
  beforeMount() {
    this.show();
  },
  methods: {
    confirmDelete() {
      if (!this.id) return this.$message.warning('缺少学员信息，请刷新页面后重新尝试！');
      if (this.isDeleting) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        const { update_time, delete_cause } = this.student;

        this.isDeleting = true;
        const { isError } = await destroy(this.id, { update_time, delete_cause });
        this.isDeleting = false;
        if (isError) return;

        RouteConfig.studentDeletedList.push();
      });
    },
    applyDelete() {
      if (!this.id) return this.$message.warning('缺少学员信息，请刷新页面后重新尝试！');
      if (this.isDeleting) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        const { delete_cause } = this.student;

        this.isDeleting = true;
        const { isError } = await store({ student_id: this.id, delete_cause });
        this.isDeleting = false;
        if (isError) return;

        RouteConfig.studentDeletionRequestList.push();
      });
    },
    async show() {
      if (this.isLoading) return;

      this.isLoading = true;
      const { isError, data } = await show(this.id);
      this.isLoading = false;
      if (isError) return;

      const { student } = this;
      Object.keys(data).forEach(key => {
        if (key in student) student[key] = data[key];
      });
    },
  },
};
</script>
